package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.AnnotatedString

@Composable
fun ItineraryServicesReorderDisconnectServiceDialog(
    isVisible: Boolean,
    onConfirm: () -> Unit,
    onDismissRequest: () -> Unit,
) {
    val annotatedString = remember {
        AnnotatedString(
            text = """
            You are about to disconnect these services and the itinerary will be updated. You can re-connect them at any time.

            Would you like to continue?
        """.trimIndent()
        )
    }

    ItineraryServicesReorderDialog(
        title = "Disconnect services?",
        message = annotatedString,
        isVisible = isVisible,
        onConfirm = onConfirm,
        onDismissRequest = onDismissRequest,
    )
}